const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userId: state => state.user.userId,
  name: state => state.user.name,
  roleId: state => state.user.roleId,
  roles: state => state.user.roles,
  nameEn: state => state.user.nameEn,

  info: state => state.role.info,
  messageCnt: state => state.notice.message_cnt,
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js